module.exports = __webpack_public_path__ + "static/media/icon-tip.70d79e84.svg";